module.exports = __webpack_public_path__ + "static/img/child _porn.58f41313.png";